import HTMLIcon from '../assets/web-skill/html.png'
import CssIcon from '../assets/web-skill/css.png'
import SassIcon from '../assets/web-skill/sass.png'
import tailwindIcon from '../assets/web-skill/tailwind.png'
import jsIcon from '../assets/web-skill/javascript.png'
import tsIcon from '../assets/web-skill/typescript.png'
import reactJsIcon from '../assets/web-skill/reactjs.png'

export const WebSkillList = [
    { icon: HTMLIcon, title: "HTML" },
    { icon: CssIcon, title: "CSS" },
    { icon: SassIcon, title: "Sass" },
    { icon: tailwindIcon, title: "Tailwind Css" },
    { icon: jsIcon, title: "Javascript" },
    { icon: tsIcon, title: "Typescript" },
    { icon: reactJsIcon, title: "ReactJs" },
];